import React from 'react';
import './CreatedByLine.css';

/**
 * "Created by Anna Trader · 14 Oct 2026, 09:12" under a record's name.
 *
 * Audit trail (go-live card 1248h535zfw; Chris 2026-10-19): bid/offers,
 * recaps and deliveries say who created them and when. Only where we are
 * sure: with no name on record the line shows the date alone, and with no
 * date it shows nothing. One home for the wording.
 */
export const createdByText = (name, when) => {
  if (!when) return '';
  const moment = new Date(when);
  if (Number.isNaN(moment.getTime())) return '';
  const date = moment.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  const time = moment.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  return name ? `Created by ${name} · ${date}, ${time}` : `Created ${date}, ${time}`;
};

export default function CreatedByLine({ name, when, className = '' }) {
  const text = createdByText(name, when);
  if (!text) return null;
  return (
    <span className={`hms-created-by-line ${className}`.trim()} data-testid="created-by-line">
      {text}
    </span>
  );
}
